export default {"src":"/_next/static/media/mistake.af71949b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};